// We enforce not to import MUI `Checkbox` so all Checkbox
// components will use this component. Thus we need to disable the lint rule.
// eslint-disable-next-line no-restricted-imports
import { Checkbox as MuiCheckbox, CheckboxProps } from '@material-ui/core';
import { css } from '@emotion/react';

import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors';
// import { colors } from 'styles/theme';

const checkboxCss = (colors: IColors) => css`
	&.MuiCheckbox-root {
		font-size: inherit;

		&.MuiCheckbox-colorPrimary {
			color: ${colors.tx_text_primary};

			&.Mui-checked {
				color: ${colors.tx_system};
			}
		}
	}

	.MuiSvgIcon-root {
		font-size: inherit;
	}
`;

/**
 * Material UI Checkbox wrapper.
 *
 * @see
 * [Checkbox](https://material-ui.com/components/checkboxes/)
 * @see
 * [Checkbox API](https://material-ui.com/api/checkbox/)
 */
function Checkbox({ color = 'primary', ...restProps }: CheckboxProps) {
	const { colors } = useColors();
	return <MuiCheckbox css={checkboxCss(colors)} color={color} {...restProps} />;
}

export default Checkbox;
